//
//
//
//
//
//
//
//

export default {
  props: {
    messageColors: {
      type: Object,
      required: true
    }
  }
}
